// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"446":"59c25a8b","787":"33879777","821":"a336059f"}[chunkId] + ".chunk.js";
};